/*eslint-disable @typescript-eslint/no-explicit-any*/

import { Backdrop, CircularProgress } from "@mui/material";
import React, { PropsWithChildren, type JSX } from "react";

export type IsLoadingProps  = {
    isLoading: boolean;
} & PropsWithChildren<any>;

export const WithIsLoadingHOC = (WrappedComponent: React.ComponentType<React.PropsWithChildren<React.PropsWithChildren<IsLoadingProps>>>) => {

    return function HOC({isLoading, ...props}: IsLoadingProps): JSX.Element {
        
        // if the wrapped component has a visible property then honor it, otherwise,
        // default to true
        const visible: boolean = props.hasOwnProperty("visible") ? props["visible"] as boolean : true;
        
        return (
            <>
                {isLoading && visible &&
                    <Backdrop sx={{
                        zIndex: theme => theme.zIndex.drawer + 1,
                        color: '#fff',
                        position: 'absolute'
                    }} open={true}>
                         <CircularProgress></CircularProgress>
                    </Backdrop>
                }
                <WrappedComponent isLoading={isLoading} {...props}></WrappedComponent> 
            </>
        );
    }
}

export default WithIsLoadingHOC;